<app-wrapper [wrapperCssClass]="'body-special'"
             [isLoginPage]="true">
    <div class="kc-login-shell">
        <div class="kc-card">
            <header class="kc-card__header">
                <img class="kc-card__logo"
                     src="./assets/gfx/logo-no-text-white.png"
                     alt="" />
                <h1 class="kc-card__title">{{ 'Welcome to Business Process Analyzer' | translate }}</h1>
            </header>

            <div class="kc-card__body">
                <!-- KEYCLOAK -->
                <button *ngIf="keycloakActive"
                        (click)="login()"
                        class="btn btn-primary text-light kc-card__action">
                    {{ 'Log in' | translate }}
                </button>
                <!-- CAS -->
                <a *ngIf="!keycloakActive"
                   [href]="loginLink"
                   class="btn btn-primary text-light kc-card__action">
                    {{ 'Authenticate via CAS' | translate }}
                </a>

                <p *ngIf="error" class="kc-card__error">
                    {{ error | translate }}
                </p>
            </div>

            <footer class="kc-locale">
                <a *ngFor="let lang of translate.getLangs()"
                   class="kc-locale__item"
                   [class.active]="lang === currentLang"
                   href="#"
                   (click)="setLang(lang); $event.preventDefault()">{{ lang }}</a>
            </footer>
        </div>
    </div>
</app-wrapper>
